import React from 'react'

import { Typography, Box, Grid } from '@material-ui/core'

import BaseDialog from 'components/BaseDialog'

import useStyles from './styles'

export const DaiUploadDialog = ({ open, setOpen, inputFileId }) => {
  const classes = useStyles()

  const handleContinue = () => {
    const fileInput = document.getElementById(inputFileId)
    if (fileInput) fileInput.click()

    setOpen(false)
  }

  return (
    <BaseDialog
      title="Upload de Documentos"
      open={open}
      setOpen={setOpen}
      closeButtonText="Fechar"
      {...(inputFileId && {
        actionButton: handleContinue,
        actionButtonText: 'Continuar',
      })}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Prevenção de riscos</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.firstText}>
            Para garantir privacidade e boas práticas, evite anexar documentos
            que contenham <strong>dados pessoais</strong>,{' '}
            <strong>confidencialidade</strong> ou{' '}
            <strong>cláusulas sensíveis</strong>. Sempre que possível, anexe
            apenas{' '}
            <strong>modelos de documentos utilizados na organização</strong>.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="row">
            <Typography>
              Caso não seja possível remover os dados, a plataforma adota{' '}
              <strong>padrões de segurança</strong> para manter seus arquivos
              armazenados de forma segura.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

export default DaiUploadDialog
